<!--
 * @Descripttion: 
 * @version: 
 * @Author: Francis
 * @Date: 2022-07-27 00:50:40
 * @LastEditors: Francis
 * @LastEditTime: 2022-07-27 02:02:41
-->
<template>
  <div class="bidWin">
    <div class="list">
      <van-pull-refresh
        v-model="refreshing"
        success-text="刷新成功"
        @refresh="onRefresh"
      >
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <businessItem
            @action="changeStatus"
            v-for="(item, index) in tableList"
            :key="index"
            :info="item"
          ></businessItem>
        </van-list>
      </van-pull-refresh>
    </div>
    <van-popup v-model="showDkLog" position="center" class="showDkLog">
      <div class="inner">
        <p>打卡人员：{{ dkLogInfo.dkPerson || "--" }}</p>
        <p>打卡时间：{{ dkLogInfo.createTime || "--" }}</p>
        <p>打卡地点：{{ dkLogInfo.location || "--" }}</p>
        <p @click="closeRefund" class="btn">确定</p>
      </div>
    </van-popup>

    <van-popup
      class="bidPopUp"
      v-model="show"
      closeable
      round
      :style="{ height: '164px', width: '270px' }"
      @open="openPick"
    >
      <p class="popUpTitle">安装人员</p>
      <div class="pickUnit" @click="showUnit = true">
        <p>{{ currentUnit.name }}</p>
      </div>
      <van-button class="unitButton" type="primary" @click="submit"
        >指派</van-button
      >
    </van-popup>
    <van-popup v-model="showUnit" position="bottom" :style="{ height: '30%' }">
      <van-picker
        show-toolbar
        title="选择安装人员"
        :columns="unitList"
        @confirm="onConfirm"
        value-key="name"
        @cancel="onCancel"
      />
    </van-popup>

    <van-notify v-model="showNotice">
      <span>请选择安装人员</span>
    </van-notify>
  </div>
</template>

<script>
import {
  dispatchOrderList,
  dispatchWorkerList,
  dispatchOrderNotice,
  dispatchDkLogList,
  generate,
} from "@/utils/network/interface";
import businessItem from "./item";
import { Dialog } from "vant";
export default {
  name: "bidWin",
  components: {
    businessItem,
  },
  props: {
    keyWord: String,
  },

  data() {
    return {
      tableList: [],
      refreshing: false,
      loading: false,
      pageInfo: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
      },
      finished: false,
      dkLogInfo: {},
      showDkLog: false,
      // 区分小船工单和指派
      isboat: "",
      show: false,
      showUnit: false,
      unitList: [],
      currentUnit: {},
      showNotice: false,
    };
  },
  watch: {
    keyWord(newVal, oldVal) {
      this.pageInfo.pageNum = 1;
      this.tableList = [];
      this.onLoad();
    },
  },
  created() {
    this.getUnitList();
  },
  mounted() {},
  methods: {
    onLoad() {
      setTimeout(() => {
        if (this.refreshing) {
          this.tableList = [];
          this.refreshing = false;
        }
        const { pageSize, pageNum } = this.pageInfo;
        let obj = { type: 2, pageSize, pageNum, bizName: this.keyWord };
        dispatchOrderList(obj)
          .then((res) => {
            if (res.code === 200) {
              this.tableList = this.tableList.concat(res.rows);
              this.pageInfo.pageNum++;
              this.pageInfo.total = res.total;
              this.loading = false;
              if (this.tableList.length >= res.total) {
                this.finished = true;
              }
            } else {
              this.loading = false;
              this.finished = true;
            }
          })
          .catch((err) => {});
      }, 1000);
    },
    getData() {
      let obj = { type: 2, pageSize: 10, pageNum: 1, bizName: this.keyWord };
      dispatchOrderList(obj)
        .then((res) => {
          this.refreshing = false;
          this.loading = false;
          if (res.code == 200) {
            this.tableList = res.rows;
            this.pageInfo.pageNum++;
            this.pageInfo.total = res.total;
          }
        })
        .catch((err) => {});
    },
    onRefresh() {
      this.finished = false;
      this.loading = true;
      this.pageInfo.pageNum = 1;
      this.getData();
    },
    changeStatus(data, methods) {
      this.currentRow = data;
      let params = {
        // "acceptPerson": data.acceptPerson,
        id: data.id,
      };
      if (methods == 5) {
        dispatchDkLogList(params).then((res) => {
          if (res.code == 200) {
            if (res.data.length > 0) {
              this.dkLogInfo = res.data[0];
              this.showDkLog = true;
            } else {
              this.$toast("暂无打卡记录");
            }
          }
        });
      } else if (methods == 1) {
        dispatchOrderNotice(params).then((res) => {
          if (res.code === 200) {
            this.$toast.success("提醒成功");
          } else {
          }
        });
      } else if (methods == 999) {
        Dialog.confirm({
          title: "提示",
          message: "是否生成小船工单？",
        })
          .then(() => {
            //  设置小船工单
            generate({
              id: this.currentRow.id,
            }).then((res) => {
              console.log(res);
              if (res.code !== 200) {
                this.$toast({
                  type: "fail",
                  message: res.msg,
                });
              } else {
                this.currentRow = {};
                this.currentUnit = {};
                this.show = false;
                this.pageInfo.pageNum = 1;
                this.getData();
              }
            });
          })
          .catch(() => {
            // on cancel
          });
      }
    },
    getUnitList() {
      dispatchWorkerList().then((res) => {
        console.log(res);
        this.unitList = res.data;
      });
    },
    closeRefund() {
      this.showDkLog = false;
      this.dkLogInfo = {};
    },
    onConfirm(value, index) {
      // console.log(value,index)
      this.currentUnit = this.unitList[index];
      this.showUnit = false;
    },
    openPick() {
      this.currentUnit = {};
    },
    onCancel() {
      this.showUnit = false;
    },
    submit() {
      if (!this.currentUnit.id) {
        this.showNotice = true;
        setTimeout(() => {
          this.showNotice = false;
        }, 2000);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.bidWin {
  .bidPopUp {
    padding: 20px;
    .popUpTitle {
      font-size: 14px;
      font-family: Source Han Sans CN, Source Han Sans CN-Medium;
      font-weight: 500;
      text-align: left;
      color: #333333;
      line-height: 22px;
      margin-bottom: 10px;
    }
    .pickUnit {
      height: 30px;
      background: #eeeeee;
      border: 1px solid #44b1f9;
      border-radius: 5px;
      line-height: 30px;
      background: url("../../../../assets/accountant/selectDown.png")
        calc(100% - 10px) center no-repeat;
      background-size: 12px 10px;
      margin-bottom: 25px;
      padding-left: 10px;
      padding-right: 25px;
      font-size: 14px;
      p {
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
    }
    .unitButton {
      width: 142px;
      height: 28px;
      background: #44b1f9;
      border-radius: 5px;
      display: block;
      margin: 0 auto;
      border: 1px solid #44b1f9;
    }
  }
  .showDkLog {
    width: 320px;
    height: 210px;
    background: #ffffff;
    border-radius: 20px;
    padding: 40px 20px 0;
    line-height: 2;
    font-size: 14px;
    font-family: Source Han Sans CN, Source Han Sans CN-Medium;
    font-weight: 500;
    text-align: left;
    color: #666666;
    .btn {
      width: 142px;
      height: 28px;
      background: #44b1f9;
      border-radius: 5px;
      text-align: center;
      color: #fff;
      line-height: 2;
      margin: 30px auto 0;
    }
  }
}
</style>
